import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  DELETE_STOCK,
  GET_DOSAGE,
  GET_INVENTORY_LISTING,
  GET_TARGET_CROP_CONCERN_AND_DOSAGES,
  REMOVE_SALE,
  SALE_LIST,
  UPDATE_INVENTORY_STOCK,
  UPDATE_SALE,
  UPDATE_STOCK_STATUS,
} from "../../utils/queries";
import { createGraphQLThunk } from ".";

export const inventoryListThunk = createAsyncThunk(
  "inventoryListSlice/inventoryListThunk",
  createGraphQLThunk({
    query: GET_INVENTORY_LISTING,
    getVariables: ({ inventoryListingFilters }) => ({
      inventoryListingFilters,
    }),
    responseKey: "getInventoryListing",
    url: process.env.REACT_APP_VENDOR,
  })
);

export const updateStockStatusThunk = createAsyncThunk(
  "updateStockStatusSlice/updateStockStatusThunk",
  createGraphQLThunk({
    query: UPDATE_STOCK_STATUS,
    getVariables: ({ productVariantInventory }) => ({
      productVariantInventory,
    }),
    responseKey: "updateStockStatus",
    url: process.env.REACT_APP_VENDOR,
    onSuccessMessage: "Status Changed Successfully",
  })
);

export const deleteStockThunk = createAsyncThunk(
  "deleteStockSlice/deleteStockThunk",
  createGraphQLThunk({
    query: DELETE_STOCK,
    getVariables: ({ productVariantInventory }) => ({
      productVariantInventory,
    }),
    responseKey: "deleteStock",
    url: process.env.REACT_APP_VENDOR,
    onSuccessMessage: "Stock Deleted Successfully",
  })
);

export const updateSaleThunk = createAsyncThunk(
  "updateSaleSlice/updateSaleThunk",
  createGraphQLThunk({
    query: UPDATE_SALE,
    getVariables: ({ vendorProductVariantSale }) => ({
      vendorProductVariantSale,
    }),
    responseKey: "updateSale",
    url: process.env.REACT_APP_VENDOR,
    onSuccessMessage: "Sale Updated Successfully",
  })
);

export const detailsSaleListThunk = createAsyncThunk(
  "detailsSaleListSlice/detailsSaleListThunk",
  createGraphQLThunk({
    query: SALE_LIST,
    getVariables: ({ inventoryProductId }) => ({
      inventoryProductId,
    }),
    responseKey: "getStockEntities",
    url: process.env.REACT_APP_VENDOR,
  })
);

export const removeSaleThunk = createAsyncThunk(
  "removeSaleSlice/removeSaleThunk",
  createGraphQLThunk({
    query: REMOVE_SALE,
    getVariables: ({ inventoryProductId }) => ({
      inventoryProductId,
    }),
    responseKey: "removeSale",
    url: process.env.REACT_APP_VENDOR,
  })
);

export const updateStockThunk = createAsyncThunk(
  "updateStockSlice/updateStockThunk",
  createGraphQLThunk({
    query: UPDATE_INVENTORY_STOCK,
    getVariables: ({ stockPostRequest }) => ({
      stockPostRequest,
    }),
    responseKey: "updateStock",
    url: process.env.REACT_APP_VENDOR,
  })
);

export const getDosageThunk = createAsyncThunk(
  "getDosageSlice/getDosageThunk",
  createGraphQLThunk({
    query: GET_DOSAGE,
    getVariables: ({ animalDosageRequest }) => ({
      animalDosageRequest,
    }),
    responseKey: "getDosage",
    url: process.env.REACT_APP_VENDOR,
  })
);

export const targetCropConcernThunk = createAsyncThunk(
  "targetCropConcernSlice/targetCropConcernThunk",
  createGraphQLThunk({
    query: GET_TARGET_CROP_CONCERN_AND_DOSAGES,
    getVariables: ({ cropId,productId }) => ({
      cropId,productId,
    }),
    responseKey: "getTargetCropConcernAndDosages",
    url: process.env.REACT_APP_VENDOR,
  })
);
